import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

import { selectEnvironmentTasksEntry } from "../environmentTasks.selectors";

import { fetchEnvironmentTasksThunk } from "./fetchEnvironmentTasks.thunk";

import type { EnvironmentTasksParams } from "../types";

/**
 * Idempotent loader — skips the fetch when a load is in flight, a non-retryable
 * error already occurred, or the environment has already loaded once. Safe to
 * call from the card's hook on every mount. `hasLoaded` (not "has data") is the
 * guard, so an environment with zero declared tasks does not refetch in a loop.
 */
export const ensureEnvironmentTasksLoaded = createAppAsyncThunk(
  "environmentTasks/ensureLoaded",
  async (params: EnvironmentTasksParams, { dispatch, getState }) => {
    const entry = selectEnvironmentTasksEntry(getState(), params);

    if (entry.isLoading) return { skipped: true, reason: "already_loading" };
    if (entry.isNonRetryableError)
      return { skipped: true, reason: "non_retryable_error" };
    if (entry.hasLoaded) return { skipped: true, reason: "already_loaded" };

    const result = await dispatch(fetchEnvironmentTasksThunk(params));
    return { loaded: true, result };
  }
);
